//Waypoints doesn't support ES6 modules as of 09-2018
//https://github.com/imakewebthings/waypoints/issues/453#issuecomment-143401197
//https://github.com/imakewebthings/waypoints/issues/458#issuecomment-151735949
//https://medium.com/hard-work/waypoints-with-npm-e8651893813
require('waypoints/lib/noframework.waypoints.min');

export const UI = {

	mobile : /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent),
	windowWidth : null,
	windowHeight : null,
	debug : true,

	
	// calculate and store viewport dimensions
	init : function(windowWidth) {

		this.windowWidth = window.innerWidth;
		this.windowHeight = window.innerHeight;

		//if(this.debug) 
		console.log( 'Window width: '+this.windowWidth+ ', Window height: '+this.windowHeight );	

		//check if 'this' wasn't hijacked...
		//console.log(this);

	},

	nav : {
		self : this,
		menuClass : 'nav-top',
		hasSubmenuClass : 'has-submenu',
		submenuClass: 'sub-menu',
		openClass : 'open',

		/**
		 *	Binds multi-level navigation UX to menu element
		 *
		 * @param {string} menuClass
		 * @param {string} hasSubmenuClass
		 * @param {string} submenuClass
		 * @param {string} openClass
		 */
		bind : function(menuClass = this.menuClass, hasSubmenuClass = this.submenuClass, submenuClass = this.submenuClass, openClass = this.openClass) {

			// parent object {nav}
			let self = this;
			
			const menuEl = document.querySelector('.'+menuClass);

			if(menuEl === null) return;

			let navLinks = menuEl.querySelectorAll('a');

			navLinks.forEach( function(item) {

				let li = item.parentNode;

				if( li.classList.contains(hasSubmenuClass) ) {

					//bind event to <button>, but only on mobile
					let button = li.querySelector('.do-toggle-subnav');

					if(button !== null) {
						button.addEventListener('click', function(event) {
							if( UI.windowWidth <= 960 ) {
								self.toggleSubmenu(li, openClass);
							}
						});
					}

					//bind event to <a>
					item.addEventListener('click', function(event) {

						if( UI.windowWidth <= 960 ) {
							
							//deprecated, on mobile we are binding event to special <button> element to allow both options: toggling nav AND clicking link
							//self.toggleSubmenu(li, openClass);
							//event.preventDefault();
							//console.log( ' menu link clicked and we are on mobile-width ' );

						// on desktop-width toggle submenu only for first level (we are checking this via direct parent class)
						// using closest() method, see: https://developer.mozilla.org/en-US/docs/Web/API/Element/closest for reference (older browsers might need polyfills)
						// and for alternatives:
						// http://clubmate.fi/jquerys-closest-function-and-pure-javascript-alternatives/
						// http://codeblog.cz/vanilla, http://youmightnotneedjquery.com/, https://gist.github.com/joyrexus/7307312						
						} else if ( UI.windowWidth > 960  ) {
							console.log( ' menu link clicked and we are on desktop-width ' );
														
							if(li.closest('ul').classList.contains('menu')) {
								
								self.toggleSubmenu(li, openClass);
								
								if(!li.querySelectorAll('.open').length)
								li.querySelectorAll('.'+hasSubmenuClass)[0].classList.add('open');

								event.preventDefault();	
															
							} else if( li.dataset.depth == 1) {

								// // prevent closing if submenu is already open
								if(!li.classList.contains('open'))
								self.toggleSubmenu(li, openClass);
								
								event.preventDefault();	
							}

							
						}

						

					});

				}				

			});

			self.toggleMenu(menuEl);

		},

		toggleMenu : function(menu) {

			

			const button = document.querySelector('.do-toggle-nav');

			button.addEventListener('click', function(event) {
				menu.classList.toggle('open');
				button.classList.toggle('open');
				event.preventDefault();
			});

		},

		toggleSubmenu : function (li, openClass) {

			//select siblings
			let siblings = Array.prototype.filter.call(li.parentNode.children, function(child){
				return child !== li;
			});			

			//remove open class from siblings
			siblings.forEach( function(sibling) {
				sibling.classList.remove(openClass);
			});

			// toggle open class
			li.classList.toggle(openClass);	

		},

	},

	resizeHeaderOnScroll : {
		
		header : 'header-top',
		toggleClass : 'header--fixed',
		

		bind : function() {

			if( UI.windowWidth <= 960 ) return;

			const self = this;
			const header = document.getElementById(this.header);

			const waypoint = new Waypoint({

				element: document.getElementById('body'),
				handler: function(direction) {
					if (direction === 'down') {					
						header.classList.add(self.toggleClass);
					} else if (direction === 'up') {
						header.classList.remove(self.toggleClass);
					}				
				},
				offset: function() {
					return -200;
				}

			});			
		}
	} 
	
}


